var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeepControl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 34@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "30 0 55.9807621 15 55.9807621 45 30 60 4.01923789 45 4.01923789 15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-32.5%",
    y: "-32.5%",
    width: "185.0%",
    height: "185.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.622987115   0 0 0 0 0.642494553   0 0 0 0 0.759539176  0 0 0 0.4 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Barlow-Marshall---Home-V2",
    transform: "translate(-529.000000, -1990.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(538.000000, 1999.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon-Copy-15"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-controls-1214603",
    transform: "translate(19.000000, 18.000000)",
    stroke: "#2283FB",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14279334,19.8940435 C2.71465424,20.1245995 2.17012206,19.9715086 1.92381231,19.5477507 L0.123883671,16.450991 C-0.121209135,16.0293752 0.0173898843,15.4822386 0.43194787,15.2305473 L1.67995858,14.4721375 C2.0951361,14.2195376 2.43158832,13.6212419 2.43127855,13.1402455 L2.4300439,10.8582563 C2.42973502,10.3754164 2.09203842,9.77867012 1.67748486,9.52667158 L0.42978392,8.76826175 C0.0142966303,8.51596473 -0.124302389,7.97126863 0.122029489,7.54781802 L1.92412651,4.45228742 C2.16921931,4.03067161 2.71589332,3.87634719 3.14310753,4.1063019 L4.42939671,4.79917718 C4.85723046,5.02942597 5.54836695,5.01962871 5.96819099,4.77958134 L7.96132631,3.63964019 C8.38329217,3.39836508 8.7354806,2.810209 8.74813683,2.32824697 L8.78641308,0.876917973 C8.79906887,0.394078057 9.20529454,0.00245098957 9.69792732,0.0021437278 L13.3017673,1.78653863e-07 C13.7925725,-0.000305587412 14.2006253,0.391917129 14.2135913,0.87416008 L14.2518676,2.32579634 C14.2645238,2.80894352 14.6185797,3.39743759 15.0386781,3.63811134 L17.0311939,4.77923764 C17.4531598,5.02081562 18.1430837,5.02938822 18.5706077,4.79913943 L19.8572067,4.10595688 C20.2853458,3.87540082 20.8298779,4.0284918 21.0761877,4.45224967 L22.8761163,7.54900932 C23.1212091,7.97062514 22.9826101,8.51776177 22.5680521,8.76945305 L21.3200414,9.52786288 C20.9048639,9.78046277 20.5684117,10.3787585 20.5687215,10.8597548 L20.5699561,13.1417441 C20.570265,13.624584 20.9079616,14.2213302 21.3225151,14.4733288 L22.5702161,15.2317386 C22.9857034,15.4840356 23.1243024,16.0287317 22.8779705,16.4521823 L21.0758735,19.5477129 C20.8307807,19.9693288 20.2841067,20.1236532 19.8568925,19.8936985 L18.5706033,19.2008232 C18.1427695,18.9705744 17.4516331,18.9803716 17.031809,19.220419 L15.0386737,20.3603602 C14.6167078,20.6016353 14.2645194,21.1897914 14.2518632,21.6717534 L14.2135869,23.1230824 C14.2009311,23.6059223 13.7947055,23.9975494 13.3020727,23.9978566 L9.69823267,24.0000002 C9.20742752,24.0003059 8.79937466,23.6080832 8.78640866,23.1258403 L8.74813241,21.674204 C8.73547617,21.1910568 8.38142029,20.6025628 7.96132188,20.361889 L5.9688061,19.2207627 C5.54684023,18.9791847 4.85691627,18.9706121 4.42939228,19.2008609 L3.14279334,19.8940435 Z M8.50031404,16.3292855 C10.8916622,17.7099109 13.9490766,16.8907426 15.3292854,14.4996861 C16.7099107,12.108338 15.8907424,9.05092358 13.499686,7.67071482 C11.1083378,6.29008946 8.0509234,7.10925773 6.67071464,9.50031422 C5.29008928,11.8916623 6.10925755,14.9490768 8.50031404,16.3292855 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeepControl);
export default __webpack_public_path__ + "static/media/keep-control.90ecf32fa57900e73145c79c942650eb.svg";
export { ForwardRef as ReactComponent };